import React from "react";

import { EntriesPanel } from "../../components/entry/index.js";

export default () => <EntriesPanel />;
